/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFilterListIcon20Light = forwardRef('UiFilterListIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.5 4a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1h-15Z" }),
        React.createElement("path", { d: "M5 9.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M7.5 14.5A.5.5 0 0 1 8 14h4a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5Z" })));
});
